import React from "react";
import { Link, graphql, StaticQuery } from "gatsby";
import PropTypes from "prop-types";
import { kebabCase } from "lodash";
import { nanoid } from "nanoid";
import EnhancedLink from "./EnhancedLink";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import logo from "../img/logo/hcs-text-logo-white.svg";

FontAwesomeIcon.autoAddCss = false;

function compare(a, b) {
  if (!a.name || !b.name) return 0;

  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
}

const NavbarTemplate = class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      navBarActiveClass: "",
    };
  }

  toggleHamburger() {
    // toggle the active boolean in the state
    this.setState(
      {
        active: !this.state.active,
      },
      // after state has been updated,
      () => {
        // set the class in state for the navbar accordingly
        this.state.active
          ? this.setState({
              navBarActiveClass: "is-active",
            })
          : this.setState({
              navBarActiveClass: "",
            });
      }
    );
  }

  render() {
    const { data } = this.props;

    const menu = data.markdownRemark.frontmatter.navigation.topMenu;

    const gatsbyConfig = data.site.siteMetadata;
    const siteConfig = data.markdownRemark.frontmatter.site;

    const phonenumber = siteConfig.phone;

    let name = null;

    siteConfig.name ? (name = siteConfig.name) : (name = gatsbyConfig.title);

    let navigation = [];

    navigation["MTB Shuttles"] = [];
    navigation["Meeting Locations"] = [];
    navigation["River Shuttles"] = [];
    navigation["Blog"] = [];
    navigation["Galleries"] = [];
    navigation["Store"] = [];

    // build the sub-nabivagtion objects
    const { edges: trails } = data.trails;
    const { edges: departures } = data.departures;
    const { edges: categories } = data.categories;

    let uniqueCategories = [];
    let categoryCounter = [];

    categories.forEach(({ node: post }) => {
      if (post.frontmatter.category) {
        if (!categoryCounter[post.frontmatter.category]) {
          categoryCounter[post.frontmatter.category] = 1;

          uniqueCategories.push({
            name: post.frontmatter.category,
            slug: "/category/" + kebabCase(post.frontmatter.category),
          });
        }
      }
    });

    let trailSlug = "",
      trailTitle = "",
      departureTitle = "";

    navigation["Maps"] = [
      {
        name: "Whole Enchilada Lower Section",
        slug: "/maps/the-whole-enchilada/",
        sortOrder: 10,
      },
      {
        name: "Mag 7",
        slug: "/maps/mag-7/",
        sortOrder: 30,
      },
      {
        name: "Porcupine Rim Classic",
        slug: "/maps/porcupine-rim/",
        sortOrder: 40,
      },
      {
        name: "Raptor Route",
        slug: "/maps/raptor-route/",
        sortOrder: 20,
      },
      {
        name: "Moab Brands / Bar-M",
        slug: "/maps/moab-brands-bar-m/",
        sortOrder: 50,
      },
      {
        name: "Slickrock",
        slug: "/maps/slickrock/",
        sortOrder: 60,
      },
      {
        name: "San Juan Huts",
        slug: "/maps/san-juan-huts/",
        sortOrder: 70,
      },
      {
        name: "Kokopelli Trail",
        slug: "/maps/kokopelli-trail/",
        sortOrder: 80,
      },
      {
        name: "Other Classic Trails",
        slug: "/maps/other-classic-trails/",
        sortOrder: 100,
      },
    ];

    navigation["Galleries"].push({
      name: "Captain Ahab",
      slug: "/galleries/captain-ahab/",
    });

    navigation["River Shuttles"] = [
      {
        name: "Cataract Canyon",
        slug: "/river-shuttles/cataract-canyon/",
      },
      {
        name: "Labyrinth Canyon",
        slug: "/river-shuttles/labyrinth-canyon/",
      },
    ];

    navigation["Guided MTB Tours"] = [
      {
        name: "Captain Ahab",
        slug: "/guided-mountain-bike-tours/captain-ahab/",
      },
      {
        name: "Mag-7",
        slug: "/guided-mountain-bike-tours/mag-7",
      },
      {
        name: "Moab Brands Trails",
        slug: "/guided-mountain-bike-tours/moab-brands-trails",
      },
      {
        name: "Slickrock",
        slug: "/guided-mountain-bike-tours/slickrock",
      },
      {
        name: "Dead Horse Point",
        slug: "/guided-mountain-bike-tours/dead-horse-point",
      },
    ];
    if (trails && trails.length) {
      trails.forEach((post) => {
        trailTitle = post.node.frontmatter.title;
        if (trailTitle === "The Whole Enchilada") {
          trailTitle = "Whole Enchilada";
        }

        if (post.node.frontmatter.trail && post.node.frontmatter.trail.smallNote) {
          trailTitle = trailTitle;
        }

        let trailNote = post.node.frontmatter.trail.smallNote || undefined;

        trailSlug = post.node.fields.slug;

        navigation["MTB Shuttles"].push({
          name: trailTitle,
          note: trailNote,
          slug: trailSlug,
        });

        navigation["Galleries"].push({
          name: post.node.frontmatter.title,
          note: trailNote,
          slug: trailSlug.replace("/mtb-shuttles/", "/galleries/"),
        });
      });

      navigation["Galleries"].push({
        name: "Videos",
        slug: "/videos/",
      });
    }
    if (departures && departures.length) {
      departures.forEach((post) => {
        departureTitle = post.node.frontmatter.title;
        if (post.node.frontmatter.listingSubtitle) {
          departureTitle =
            departureTitle + " " + post.node.frontmatter.listingSubtitle;
        }
        navigation["Meeting Locations"].push({
          name: departureTitle,
          slug: post.node.fields.slug,
        });
      });
    }
    if (uniqueCategories && uniqueCategories.length) {
      uniqueCategories.forEach((post) => {
        navigation["Blog"].push({
          name: post.name,
          slug: post.slug,
        });
      });
    }

    navigation["Store"].push({
      name: "Checkout",
      slug: "",
      className: "snipcart-checkout",
    });

    //navigation["MTB Shuttles"].sort(compare);
    // if (
    //   navigation["Meeting Locations"] &&
    //   navigation["Meeting Locations"].length
    // ) {
    //   navigation["Meeting Locations"].sort(compare);
    // }
    if (navigation["River Shuttles"] && navigation["River Shuttles"].length) {
      navigation["River Shuttles"].sort(compare);
    }
    //navigation["Guided MTB Tours"].sort(compare);

    navigation["Maps"].sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1));

    if (navigation["Galleries"] && navigation["Galleries"].length) {
      navigation["Galleries"].sort(compare);
    }

    console.log('DEBUG', navigation["Meeting Locations"]);

    return (
      <div className="navbar-wrapper">
        <nav
          className="navbar is-transparent"
          role="navigation"
          aria-label="main-navigation"
        >
          <div
            className={`section--gradient light-cammo  navbar-burger navbar-header ${this.state.navBarActiveClass}`}
            key={nanoid()}
          >
            <div className="pt-2 mb-2 has-text-black " key={nanoid()}>
              <Link
                to="/book-shuttle/"
                title="Book Shuttle"
                className="navbar-button c-inh"
              >
                Book Now!
              </Link>
              <Link
                to="tel:+1(435) 210-8082"
                title="Call Now"
                className="navbar-burger-phone c-inh"
              >
                (435) 210-8082
              </Link>
            </div>
          </div>
          <div className="container container-center mx-0" key={nanoid()}>
            <div className="navbar-brand" key={nanoid()}>
              <EnhancedLink
                to="/"
                className="navbar-logo-link"
                title={name}
                key={`${name}_topnav`}
              >
                <img
                  className="navbar-logo"
                  src={logo}
                  alt={name}
                  style={{
                    height: "200px",
                    verticalAlign: "middle",
                  }}
                />
              </EnhancedLink>
              {/* Hamburger menu */}
              <div
                className={`navbar-burger burger ${this.state.navBarActiveClass}`}
                data-target="navMenu"
                role="menuitem"
                tabIndex={0}
                onKeyPress={() => this.toggleHamburger()}
                onClick={() => this.toggleHamburger()}
                key={nanoid()}
              >
                <span />
                <span />
                <span />
                <span />
              </div>
            </div>
            <div
              id="navMenu"
              className={`navbar-menu ${this.state.navBarActiveClass}`}
              key={nanoid()}
            >
              <div className="navbar-start has-text-centered " key={nanoid()}>
                {menu.map((item) => {
                  if (navigation[item.name]) {
                    return (
                      <div
                        className="navbar-item has-dropdown is-hoverable"
                        key={nanoid()}
                      >
                        <EnhancedLink
                          className="ucase navbar-link"
                          to={item.slug}
                          key={`${item.name}_topnav`}
                        >
                          {item.name}
                        </EnhancedLink>

                        <div className="navbar-dropdown" key={nanoid()}>
                          {navigation[item.name].map((subItem) => {
                            if (!subItem.className) subItem.className = "";
                            if (subItem.slug) {
                              return (
                                <EnhancedLink
                                  className={`${subItem.className} navbar-item navbar-child`}
                                  to={subItem.slug}
                                  key={`${subItem.name}_sub_topnav`}
                                >
                                  {subItem.name} <span>{subItem.note ? subItem.note : ""}</span>
                                </EnhancedLink>
                              );
                            } else {
                              return (
                                <a
                                  className={`${subItem.className} navbar-item navbar-child`}
                                  key={`${subItem.name}_sub_topnav`}
                                >
                                  {subItem.name}
                                </a>
                              );
                            }
                          })}
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <EnhancedLink
                        className="ucase navbar-item"
                        to={item.slug}
                        key={`${item.name}_topnav`}
                      >
                        {item.name}
                      </EnhancedLink>
                    );
                  }
                })}

                <a
                  className="navbar-item"
                  href={`tel:+1${phonenumber}`}
                  title={`Call ${name} Now!`}
                >
                  <span className="nav-phone is-hidden-tablet ">
                    <FontAwesomeIcon
                      icon={faPhone}
                      style={{ height: "20px", paddingBottom: "1rem" }}
                    />
                    <br />
                    (435) 210-8082
                    <br />
                    Book Now!
                  </span>
                </a>
              </div>
            </div>
          </div>
        </nav>
      </div>
    );
  }
};

Navbar.propTypes = {
  site: PropTypes.shape({
    siteMetadata: PropTypes.shape({
      menu: PropTypes.array,
    }),
  }),
};

//export default Navbar;

export default function Navbar() {
  return (
    <StaticQuery
      query={graphql`
        query TopNav {
          site {
            siteMetadata {
              title
              property {
                url
              }
            }
          }
          markdownRemark(
            frontmatter: { templateKey: { eq: "configuration" } }
          ) {
            frontmatter {
              site {
                name
                url
                phone
              }
              navigation {
                topMenu {
                  slug
                  name: title
                }
              }
            }
          }
          trails: allMarkdownRemark(
            sort: { frontmatter: { meta: { sortOrder: ASC } } }
            filter: {
              frontmatter: { templateKey: { eq: "mtb-shuttles-post" } }
            }
          ) {
            edges {
              node {
                id
                fields {
                  slug
                }
                frontmatter {
                  title
                  trail {
                    note
                    smallNote
                  }
                }
              }
            }
          }
          departures: allMarkdownRemark(
            sort: { frontmatter: { meta: { sortOrder: ASC } } }
            filter: {
              frontmatter: { templateKey: { eq: "departure-locations-post" } }
            }
          ) {
            edges {
              node {
                id
                fields {
                  slug
                }
                frontmatter {
                  title
                  listingSubtitle
                }
              }
            }
          }
          categories: allMarkdownRemark(
            sort: { frontmatter: { category: ASC } }
            filter: { frontmatter: { templateKey: { eq: "blog-post" } } }
          ) {
            edges {
              node {
                frontmatter {
                  category
                }
              }
            }
          }
        }
      `}
      render={(data, count) => <NavbarTemplate data={data} count={count} />}
    />
  );
}
